import * as tslib_1 from "tslib";
import { AfterViewInit, ViewContainerRef } from '@angular/core';
import { InputConverter } from '../../../inputConverter';
import { ExportService } from '../../../services/export.service';
import { BaseComponent } from '../../base.component';
var ExportLayerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ExportLayerComponent, _super);
    function ExportLayerComponent(_vcr, exportService) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.exportService = exportService;
        return _this;
    }
    ExportLayerComponent.prototype.ngAfterViewInit = function () {
        this.isReady();
    };
    Object.defineProperty(ExportLayerComponent.prototype, "ExportService", {
        get: function () {
            return this.exportService;
        },
        enumerable: true,
        configurable: true
    });
    ExportLayerComponent.prototype.exportToShapeFileAndOpenUrl = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var exportParams;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        exportParams = { layerId: this.layerId };
                        return [4 /*yield*/, this.exportService.exportToShapeFileAndOpenUrl(exportParams)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], ExportLayerComponent.prototype, "layerId", void 0);
    return ExportLayerComponent;
}(BaseComponent));
export { ExportLayerComponent };
